import * as React from 'react'
import { connect } from 'react-redux'

import { UserLayout } from '@app/layouts/user'
import type { RootState } from '@app/state'

import { routes } from './routes'

import type { ConnectedProps } from 'react-redux';

const mapState = (state: RootState) => ({
  account: state.user.account,
})

const connector = connect(mapState)
type PropsFromRedux = ConnectedProps<typeof connector>

interface ScreenProps {
  children?: React.ReactNode
}

class AccountScreen extends React.Component<ScreenProps & PropsFromRedux> {
  render() {
    return (
      <UserLayout routes={routes} account={this.props.account}>
        {this.props.children}
      </UserLayout>
    )
  }
}

export default connector(AccountScreen)
